import type { TPlayer } from 'video.js'
import type { SettingsMenuContainer } from '../settings-menu-container'

import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { BaseComponent } from '../../base'
import { setQualityByDimensions } from '../quality/helpers'
import { QualityButton } from './quality-button'

/**
 * Quality menu with available quality levels
 */
@register
export class SettingsQualityMenu extends BaseComponent {
  declare options_: any
  declare container: SettingsMenuContainer | undefined

  qualityButton_: QualityButton
  menu: QualityButton['menu'] | undefined

  constructor(player: TPlayer, options: any) {
    super(player, options)

    this.qualityButton_ = new QualityButton(player, {
      title: this.localize(options.title),
      getContainer: () => this.container,
    })

    this.player_.qualityLevels().on('change', () => {
      this.update()
    })
  }

  @on(Events.Media.QualityLevelSelected)
  handleQualityLevelSelected() {
    this.update()
  }

  @on('loadedmetadata')
  onLoadedMetadataq() {
    // restore last selected quality in 'rewind' case
    const settingsMenuContainer = this.parentComponent_
    if (settingsMenuContainer.qualityState?.id !== 'auto') {
      setQualityByDimensions(this.player_, settingsMenuContainer.qualityState)
    }
  }

  override contentEl() {
    // return _parent_'s container element, so any child, added to this component,
    // will be added to the parent container's element instead
    if (!this.container) throw new Error('container is not set')
    return this.container.contentEl()
  }

  override handleLanguagechange() {
    this.qualityButton_.title(this.localize(this.options_.title))
  }

  update() {
    this.qualityButton_.update(this.menu?.hasClass('vjs-x-active'))
    this.menu = this.qualityButton_.menu
    this.addChild(this.menu)
  }

  activate() {
    if (this.menu?.el_) this.menu.addClass('vjs-x-active')
  }

  deactivate() {
    if (this.menu?.el_) this.menu.removeClass('vjs-x-active')
  }
}

SettingsQualityMenu.options = {
  createEl: false, // this component is opaque, it has no element
}
